import { list } from '../rules/list';

export const unset = {
  list: list.unset,
};
